
let methods = {
    checkAmenityNameExists(location, name) {
        if (!location.amenities) return false

        return (location.amenities.filter(
            amenity => amenity.name.toLowerCase() == name.toLowerCase()
        ) || []).length > 0
    }
}

export default {
    name: "location-info-table",
    props: ['location', 'parkingCancellationPolicies'],
    methods,
    data() {
        return {
        }
    }
}